import { RefObject } from 'react';

export interface UseSwipeOptions {
  ref: RefObject<HTMLElement>;
  thresholdPX?: number;
}

export enum SWIPE_DIRECTION {
  RIGHT = 'right',
  LEFT = 'left',
  UP = 'up',
  DOWN = 'down',
}

export type TSwipeDirection = `${SWIPE_DIRECTION}`;
